import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/acolhimento-acs-tacs`

    return {
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        create(filaId) {
            return repository.get(`${baseUrl}/create/${filaId}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
    }
}